<div class="d-flex align-items-center justify-content-between mb-3">
  <div class="card-heading">Sender Information</div>
  <button mat-icon-button [disabled]="isLoading" (click)="dialogRef.close()" type="button">
    <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
  </button>
</div>
<form
  [formGroup]="senderInfoForm"
  (ngSubmit)="formSubmit()"
  *ngIf="!result.isResult; else resultBlock"
>
  <div class="row">
    <div class="form-group col-md-6" *ngFor="let item of formControls">
      <label>{{ item }}:</label>
      <input
        type="text"
        class="form-control"
        [placeholder]="'Enter ' + item"
        [formControlName]="item"
      />
      <app-error-message
        [formName]="senderInfoForm"
        [fieldName]="item"
        [type]="'group'"
      >
      </app-error-message>
    </div>
  </div>

  <div class="d-flex justify-content-end mt-4">
    <button class="custom-btn" [disabled]="isLoading" (click)="dialogRef.close()" type="button">
      Cancel
    </button>
    <button class="custom-btn" [disabled]="isLoading">
      Save And Continue
      <span class="whiteLoader" *ngIf="isLoading"></span>
    </button>
  </div>

</form>

<ng-template #resultBlock>
  <div class="ml-3 my-3">
    <div class="card-sub-heading">Result!</div>
  </div>
  <ng-container *ngIf="result.successfull?.length > 0">
    <div class="d-flex justify-content-between px-3 py-3">
      <div>Successfully checked delivery rates for the selected orders:</div>
    </div>
    <div
      class="d-flex justify-content-between px-3"
      *ngFor="let item of result.successfull"
    >
      <div class="pb-3">
        <strong> Order ID:</strong>
        {{ item.OrderID }}
      </div>
    </div>
  </ng-container>
  <div class="d-flex mt-3">
    <div class="col-md-12 d-flex justify-content-center">
      <button class="custom-btn w-100" (click)="continue()" type="button">
        OK
      </button>
    </div>
  </div>
</ng-template>
